import React, { useEffect, useRef, useState } from 'react';
import { AiOutlineWarning } from 'react-icons/ai';
import { IoNotificationsCircleSharp } from 'react-icons/io5';
import { FaUserCircle } from 'react-icons/fa';
import { Button, Tooltip } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { BsFillCaretDownFill } from 'react-icons/bs';
import logo from '../../images/tata_motors_logo.png';
import Ipms from '../../images/ipms.svg';
import Mes from '../../images/mes_pv.svg';
import Jrl from '../../images/jlr.svg';
import mes4_ev_logo from '../../images/mes4-ev-logo.png';
import defaultStyles from './Header.module.css';
import jlrStyles from './HeaderJlr.module.css';
import config from '../../config/config';
import {
  APPLICATION_VARIANTS,
  ENV_TYPES,
  HEX_COLORS,
  JLR_PLANT,
} from '../../constants';
import { UserProfile } from '..';
import { IconButton } from '../../atomicComponents';
import { ArrowBackIcon } from '../../icons';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { setStylesAccordingToPlant } from '../../utils/utils';

const Header = props => {
  const [styles, setStyles] = useState(defaultStyles);
  const history = useHistory();
  const location = useLocation();
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);
  const [plant] = usePlantAndLinesStore().plantState;
  const [iconColor, setIconColor] = useState('#0380af');
  const { APPLICATION_VARIANT } = config;

  const redirectToApplicationLandingPage = () => {
    history.push('/');
  };

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
    if (JLR_PLANT === plant.label) {
      setIconColor(HEX_COLORS.DARK_GREEN);
    } else {
      setIconColor(HEX_COLORS.DARK_BLUE);
    }
  }, [plant]);

  const renderTestWaterMark = () => (
    <span className={styles.testTitle}>
      <strong>TEST ENVIRONMENT</strong>
      Changes made here will not impact/influence actual Production
    </span>
  );
  return (
    <div className={styles.header} {...props}>
      <div className={styles.leftContainer}>
        <img className={styles.logo} src={logo} alt="Tata Motors" />
        {location.pathname !== '/' && // TODO: Make dynamic
          !(
            location.pathname.includes('/aggregate/plan') ||
            location.pathname.includes('/chassis') ||
            location.pathname.includes('/aggregate/sequence') ||
            location.pathname.includes('/aggregate/resequence') ||
            location.pathname.includes('/aggregate/emergency-agsn') ||
            location.pathname.includes('/aggregate/dispatch') ||
            location.pathname.includes('/agsns') ||
            location.pathname.includes('/shift-configurator')
          ) && (
            <div className={styles.appName}>
              <Button
                className={styles.appNameButton}
                style={{ marginRight: '1em' }}
                onClick={redirectToApplicationLandingPage}
              >
                <Tooltip title="Go Back">
                  <ArrowBackIcon className={styles.arrowBackIcon} />
                </Tooltip>

                <span className={styles.appTitle}>Production</span>
              </Button>
            </div>
          )}
      </div>
      <div>{config.ENV_TYPE === ENV_TYPES.TEST && renderTestWaterMark()}</div>
      <div className={styles.rightContainer}>
        <div className={styles.topIcons}>
          <AiOutlineWarning className={styles.icDesable} />
          <IoNotificationsCircleSharp className={styles.icDesable} />
          <FaUserCircle 
          color={iconColor} 
          className={styles.iconButton}
            ref={profileRef}
            onClick={() => setShowProfile(true)}
          >
            <BsFillCaretDownFill style={{ marginRight: 0 }} />
          </FaUserCircle>
          <IconButton
            color={iconColor}
            className={styles.iconButton}
            ref={profileRef}
          >
            <BsFillCaretDownFill style={{ marginRight: 0 }} />
          </IconButton>
        </div>
        <a href={config.HOME_UI_BASE_URL} className={styles.homeLink}>
          {/*TODO: Restrict navigation on clicking IPMS4 icon*/}
          {APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4 ||
          APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV ? (
            JLR_PLANT === plant.label ? (
              <span>
                <img src={Jrl} className={styles.ipmsLogo} alt="MES 4.0" />
              </span>
            ) : APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV ? (
              <span>
                <img
                  src={mes4_ev_logo}
                  className={styles.mes4evLogo}
                  alt="MES 4.0"
                />
              </span>
            ) : (
              <span>
                <img src={Mes} className={styles.mesLogo} alt="MES 4.0" />
              </span>
            )
          ) : (
            <span>
              <img src={Ipms} className={styles.ipmsLogo} alt="IPMS 4.0" />
            </span>
          )}
        </a>
      </div>
      <UserProfile
        open={showProfile}
        anchorEl={profileRef.current}
        handleClose={() => setShowProfile(false)}
      />
    </div>
  );
};

Header.propTypes = {};

export default Header;
